// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Note Get
/**
 *
 * @param {{params: object, query: { search: string,  "planId": string, "employeeId": string, customerId: string, isAdmin: boolean, date: string, page: number, limit: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Note.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Note Create
/**
 *
 * @param {{"plainText": "string","planId": "string","isAdmin": boolean,"userId": "string","customerId": "string"}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Note.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Note Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Note.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Note Get ById
/**
 *
 * @param {{params: object, query: { search: string,  "planId": string, "employeeId": string, customerId: string, date: string, page: number, limit: number }}} option
 
 * @returns
 */
export const GetByUser = async (option) => {
  const response = await $api.get(Endpoints.Note.GetByUser(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Note Update
/**
 *
 * @param {{"plainText": "string","planId": "string","isAdmin": boolean,"userId": "string","customerId": "string"}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Note.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Note Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Note.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  GetByUser,
  Update,
  Delete,
};
